export default __webpack_public_path__ + "static/media/key.433a8f23.svg";